import React from 'react'
import PropTypes from 'prop-types'

import { LOWER_TEETH, UPPER_TEETH } from '../../state/plan/const'
import store from '../../../store'
import { selectProcessInstance } from '../../../process/state/instance-detail/selector'


const TeethCell = ({ teeth, position, readOnly, onChange, save, checked = false}) => {
    return (
        <td className={'teeth-cell-' + position}>
            <input
                type="checkbox"
                checked={teeth[position] || checked}
                readOnly={readOnly}
                disabled={readOnly}
                onChange={(event) => {
                    if (readOnly) {
                        return
                    }
                    onChange(position, event.currentTarget.checked)
                    save()
                }}/>
        </td>
    )
}

TeethCell.propTypes = {
    teeth: PropTypes.object.isRequired,
    position: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
}


const TeethSelect = ({ teeth, readOnly, onChange, save, isDoNotMove }) => {

    const state = store.getState()
    const processInstance = selectProcessInstance(state)
    const isSetProcess = (processInstance && processInstance.processName === 'salesorder-set')

    return (
        <table className="teeth-table">
            <tbody>
                <tr>
                    {UPPER_TEETH.map(position => {
                        return <td key={position} className={'teeth-cell-' + position}>{position}</td>
                    })}
                </tr>
                <tr>
                    {UPPER_TEETH.map(position => {
                        const additionalSetReadOnly = isSetProcess && isDoNotMove && (position === '14' || position === '15' || position === '24' || position === '25')
                        const _readonly = readOnly || additionalSetReadOnly || ((position === '16' || position === '17' || position === '18' || position === '26' || position === '27' || position === '28'))
                        return (<TeethCell
                            key={position}
                            teeth={teeth}
                            position={position}
                            onChange={onChange}
                            save={save}
                            readOnly={_readonly}
                            checked={additionalSetReadOnly}/>)
                    })}
                </tr>
                <tr className="separator">
                    {LOWER_TEETH.map(position => {
                        const additionalSetReadOnly = isSetProcess && isDoNotMove && (position === '44' || position === '45' || position === '34' || position === '35')
                        const _readonly = readOnly || additionalSetReadOnly || ((position === '46' || position === '47' || position === '48' || position === '36' || position === '37' || position === '38'))
                        return (<TeethCell
                            key={position}
                            teeth={teeth}
                            position={position}
                            onChange={onChange}
                            save={save}
                            readOnly={_readonly}
                            checked={additionalSetReadOnly}/>)
                    })}
                </tr>
                <tr>
                    {LOWER_TEETH.map(position => {
                        return <td key={position} className={'teeth-cell-' + position}>{position}</td>
                    })}
                </tr>
            </tbody>
        </table>
    )
}

TeethSelect.propTypes = {
    teeth: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    isDoNotMove: PropTypes.bool.isRequired,
}


export default TeethSelect



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/TeethSelect.js